<div class="idobelyeg-admin">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Időbélyeg-felülhitelesítés (bizonyítványok, nyomtatványok)</ion-card-title>
      <ion-card-subtitle>
        A digitális bizonyítványt 80 évig kell őrizni (Nkt. 57. § (6a)), a törzslapot és a beírási naplót nem
        szabad selejtezni, a többi kötelező nyomtatvány (20/2012. EMMI r. 94. §) is évekig őrzendő. A rendszer
        naponta ellenőrzi a tárolt aláírt példányokat, és a lejárat előtt új időbélyeget tesz rájuk; előtte a
        tanúsítványláncot és a visszavonási adatokat (LTV) is a fájlba menti, a felülírás előtti változatot pedig
        megőrzi. Az újragenerálással kiváltott, érvénytelen nyomtatványpéldány nem kerül felülhitelesítésre.
        Itt látszik az állapot és a hibák.
      </ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <div *ngIf="betolt && !a" class="ion-text-center"><ion-spinner name="crescent"></ion-spinner></div>

      <ng-container *ngIf="a">
        <p class="sor" [class.rossz]="!a.tsa?.enabled">
          <b>Időbélyeg-szolgáltató:</b>
          <ng-container *ngIf="a.tsa?.enabled; else nincsTsa"> bekapcsolva ({{ a.tsa.url }})</ng-container>
          <ng-template #nincsTsa> KIKAPCSOLVA – a felülhitelesítés nem tud lefutni. Kapcsold be: Admin › Tanúsítványkezelés › Aláírás-beállítás.</ng-template>
        </p>
        <p class="sor" [class.figyel]="!a.alairo?.igazgatoi">
          <b>Aláíró:</b>
          <ng-container *ngIf="a.alairo?.igazgatoi; else intezmenyi">
            igazgatói tanúsítvány ({{ a.alairo.igazgatoi.owner || a.alairo.igazgatoi.name }})
          </ng-container>
          <ng-template #intezmenyi> az intézmény tanúsítványa{{ a.alairo?.aktiv ? ' (' + a.alairo.aktiv.name + ')' : '' }}</ng-template>
        </p>
        <ul class="figyelmeztetes" *ngIf="a.alairo?.figyelmeztetes?.length">
          <li *ngFor="let f of a.alairo.figyelmeztetes">{{ f }}</li>
        </ul>

        <div class="kartyak">
          <div class="kartya"><span class="szam">{{ a.osszesites.osszes }}</span><span>dokumentum felügyelet alatt</span></div>
          <div class="kartya"><span class="szam">{{ a.osszesites.nyilvantartott }}</span><span>már ellenőrizve</span></div>
          <div class="kartya" [class.jo]="a.osszesites.ltv_rendben && !a.osszesites.ltv_hianyos" [class.figyel]="a.osszesites.ltv_hianyos">
            <span class="szam">{{ a.osszesites.ltv_rendben }}</span><span>LTV-adatokkal{{ a.osszesites.ltv_hianyos ? ' · ' + a.osszesites.ltv_hianyos + ' hiányos' : '' }}</span>
          </div>
          <div class="kartya" [class.rossz]="gondDb"><span class="szam">{{ gondDb }}</span><span>hibás vagy elmaradt tétel</span></div>
          <div class="kartya">
            <span class="szam kicsi">{{ a.osszesites.legkozelebbi ? (a.osszesites.legkozelebbi | date:'yyyy.MM.dd.') : '—' }}</span>
            <span>legközelebbi esedékesség</span>
          </div>
          <div class="kartya"><span class="szam">{{ a.osszesites.archiv_valtozat }}</span><span>megőrzött korábbi változat</span></div>
        </div>

        <!--  Típusonként: a kártyára kattintva a lenti listák arra a típusra szűrnek. -->
        <div class="kartyak tipus-kartyak" *ngIf="tipusok.length">
          <button type="button" class="kartya tipus" *ngFor="let t of tipusok"
                  [class.valasztott]="tipusSzuro === t.tipus" [class.rossz]="t.hibas" [class.figyel]="!t.hibas && t.ltv_hianyos"
                  (click)="tipusValaszt(tipusSzuro === t.tipus ? '' : t.tipus)">
            <span class="szam">{{ t.osszes }}</span>
            <span>{{ tipusCimke(t.tipus) }}</span>
            <span class="halvany kis" *ngIf="t.hibas || t.esedekes || t.ltv_hianyos">
              {{ t.hibas ? t.hibas + ' hibás' : '' }}{{ t.hibas && (t.esedekes || t.ltv_hianyos) ? ' · ' : '' }}{{ t.esedekes ? t.esedekes + ' esedékes' : '' }}{{ t.esedekes && t.ltv_hianyos ? ' · ' : '' }}{{ t.ltv_hianyos ? t.ltv_hianyos + ' LTV-hiányos' : '' }}
            </span>
          </button>
        </div>

        <p class="halvany">
          Utolsó ellenőrzés: {{ a.osszesites.utolso_ellenorzes ? (a.osszesites.utolso_ellenorzes | date:'yyyy.MM.dd. HH:mm') : 'még nem futott' }}
          · eddig {{ a.osszesites.belyeg_db }} új időbélyeg
          <ng-container *ngIf="a.osszesites.legkorabbi_tsa_lejarat"> · a legkorábbi TSA-tanúsítvány lejárata: {{ a.osszesites.legkorabbi_tsa_lejarat | date:'yyyy.MM.dd.' }}</ng-container>
          <ng-container *ngIf="a.riasztas"> · utolsó riasztás: {{ a.riasztas.kuldve | date:'yyyy.MM.dd. HH:mm' }} ({{ a.riasztas.darab }} tétel)</ng-container>
        </p>

        <div class="gombok">
          <ion-button fill="outline" (click)="toltes()" [disabled]="betolt || fut">Frissítés</ion-button>
          <ion-button (click)="futtat()" [disabled]="fut || !a.tsa?.enabled">
            <ion-icon slot="start" name="play-outline"></ion-icon>{{ fut ? 'Fut…' : 'Most futtasd' }}
          </ion-button>
        </div>
        <p class="halvany" *ngIf="utolsoFutas">
          Az imént: {{ utolsoFutas.ellenorizve }} ellenőrizve, {{ utolsoFutas.megujitva }} felülhitelesítve,
          {{ utolsoFutas.ltv_potolva }} LTV-pótlás, {{ utolsoFutas.hiba }} hiba.
        </p>

        <div class="szuro-sor">
          <h3 class="cim">Hibás vagy elmaradt tételek</h3>
          <ion-select class="tipus-szuro" interface="popover" label="Típus" label-placement="start"
                      [value]="tipusSzuro" (ionChange)="tipusValaszt($event.detail.value)">
            <ion-select-option value="">Minden típus</ion-select-option>
            <ion-select-option *ngFor="let t of tipusok" [value]="t.tipus">{{ tipusCimke(t.tipus) }}</ion-select-option>
          </ion-select>
        </div>
        <p class="halvany" *ngIf="!szurtGondok.length">Nincs hibás tétel{{ tipusSzuro ? ' ebben a típusban' : '' }}.</p>
        <div class="tetel rossz" *ngFor="let g of szurtGondok">
          <div>
            <span class="tipus-cimke">{{ tipusCimke(g.tipus) }}</span>
            <b>{{ g.tanulo_nev || g.oktazon || g.nev || g.dokumentum_id }}</b><ng-container *ngIf="g.tanulo_nev || g.oktazon"> · {{ g.nev }}</ng-container>
            <div class="halvany">{{ fajtaNev[g.fajta] || g.fajta }}{{ g.hiba ? ': ' + g.hiba : '' }}</div>
            <div class="halvany">
              Utolsó próba: {{ g.ellenorizve ? (g.ellenorizve | date:'yyyy.MM.dd. HH:mm') : '—' }}
              · következő: {{ g.kovetkezo ? (g.kovetkezo | date:'yyyy.MM.dd.') : '—' }}
              <ng-container *ngIf="g.tsa_lejar"> · TSA-lejárat: {{ g.tsa_lejar | date:'yyyy.MM.dd.' }}</ng-container>
            </div>
          </div>
          <ion-button size="small" fill="clear" (click)="ujraprobal(g)">Újrapróbál</ion-button>
        </div>

        <ng-container *ngIf="szurtLtv.length">
          <h3 class="cim">Hiányos LTV-adatok</h3>
          <p class="halvany">
            Ezeknél a tanúsítványlánc vagy a visszavonási adat (OCSP/CRL) nem volt teljesen beszerezhető. A fájl
            érvényes marad; a rendszer hetente újrapróbálja.
          </p>
          <div class="tetel figyel" *ngFor="let l of szurtLtv">
            <div>
              <span class="tipus-cimke">{{ tipusCimke(l.tipus) }}</span>
              <b>{{ l.tanulo_nev || l.nev || l.dokumentum_id }}</b><ng-container *ngIf="l.tanulo_nev"> · {{ l.nev }}</ng-container>
              <div class="halvany">{{ l.ltv_hiba }}</div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ion-card-content>
  </ion-card>
</div>
